module.exports = __webpack_public_path__ + "img/ghost.40f7656b.png";